module.exports = __webpack_public_path__ + "img/hospitium-07.74f8cc3e.jpg";